import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import { siteInfo } from '@/mocks/movies';

const testimonials = [
  {
    name: '王先生',
    role: '资深影迷',
    content: '丫丫影院的画质真的没话说，播放流畅不卡顿，片源更新也很快，是我每天必上的网站。特别是高清资源，比很多付费平台都好！',
    rating: 5,
  },
  {
    name: '李女士',
    role: '电视剧爱好者',
    content: '追剧神器！最新电视剧全集都有，而且不用等缓冲，画质清晰。界面清爽干净，分类也很详细，找剧超方便。强烈推荐！',
    rating: 5,
  },
  {
    name: '张同学',
    role: '大学生',
    content: '作为一个电影迷，丫丫影院简直是宝藏网站。电影资源丰富，新片更新速度快，关键是完全免费。已经成为我们宿舍的指定观影平台了。',
    rating: 5,
  },
  {
    name: '刘先生',
    role: '家庭用户',
    content: '周末全家人一起看电影的首选网站。动画片、喜剧片种类多，孩子大人都能找到喜欢的。不缓冲的体验确实很棒，再也不用看转圈圈了。',
    rating: 5,
  },
  {
    name: '陈女士',
    role: '白领',
    content: '下班后放松的最好方式就是在丫丫影院看一部好电影。界面设计简洁大方，操作方便，资源丰富，真的是良心平台。已推荐给身边所有朋友。',
    rating: 5,
  },
];

const faqs = [
  {
    question: '丫丫影院是什么？',
    answer: '丫丫影院是一个专业的免费高清影视在线观看平台，提供最新电影、电视剧全集的在线播放服务。我们致力于为用户打造流畅、高清、免费的观影体验，平台资源丰富，涵盖动作、喜剧、爱情、科幻、恐怖、动画、纪录片及热门电视剧等多种类型。',
  },
  {
    question: '丫丫影院需要注册会员吗？',
    answer: '不需要。丫丫影院完全免费开放，用户无需注册或登录即可直接在线观看所有影视资源。我们坚信优质内容应该让每个人都能轻松获取，不会有任何收费或会员限制。',
  },
  {
    question: '丫丫影院的画质怎么样？',
    answer: '丫丫影院所有资源均提供高清画质，大部分热门影片和电视剧都支持超清甚至蓝光画质。我们在保证高清画质的同时，通过先进的视频压缩技术，确保播放流畅不缓冲，让您享受影院级的观影体验。',
  },
  {
    question: '丫丫影院更新速度快吗？',
    answer: '我们的内容团队全天候关注影视动态，院线新片和热门电视剧上线后，会在最短时间内更新到平台。通常新资源会在48小时内完成更新上线，让您第一时间观看最新内容。',
  },
  {
    question: '在丫丫影院观看需要下载什么软件吗？',
    answer: '不需要下载任何软件或插件。丫丫影院是纯网页端平台，您只需使用浏览器访问官网，即可直接在线观看所有内容。支持电脑、平板、手机等多种设备，随时随地畅享影视盛宴。',
  },
  {
    question: '丫丫影院安全吗？',
    answer: '丫丫影院是官方正规平台，网站安全可靠，无弹窗广告，无恶意软件，不收集用户隐私信息。我们始终将用户的安全和体验放在首位，为您提供一个干净、安全的观影环境。',
  },
];

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16 md:pt-18">
        <nav className="w-full px-4 md:px-6 py-4" aria-label="面包屑导航">
          <ol className="flex items-center gap-2 text-sm text-foreground-500 max-w-7xl mx-auto">
            <li>
              <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">
                首页
              </Link>
            </li>
            <li>
              <i className="ri-arrow-right-s-line text-xs"></i>
            </li>
            <li>
              <span className="text-foreground-900 font-medium">关于我们</span>
            </li>
          </ol>
        </nav>

        <section className="w-full px-4 md:px-6 py-10 md:py-16">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-4">
                关于丫丫影院
              </h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                {siteInfo.slogan}
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10 mb-16">
              <div className="lg:col-span-2">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">
                  品牌介绍
                </h2>
                <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed space-y-4">
                  <p>
                    丫丫影院成立于2020年，是领先的免费高清影视在线观看平台。自创立以来，我们始终秉持"让每个人都能轻松享受高品质影视内容"的使命，致力于为广大影迷打造一个资源丰富、画质清晰、播放流畅的在线观影平台。
                  </p>
                  <p>
                    我们的片库涵盖{siteInfo.description.length > 50 ? siteInfo.description.substring(0, 80) : siteInfo.description}，拥有超过数万部电影和数千部电视剧资源，并且每天都在持续更新中。无论是院线热映大片、经典老片，还是热门电视剧、精品网剧，在丫丫影院都能找到。
                  </p>
                  <p>
                    丫丫影院的核心理念是"免费、高清、不缓冲"。我们投入大量技术资源优化视频播放体验，采用先进的CDN加速和智能转码技术，确保用户在不同网络环境下都能享受流畅的观影体验。同时我们注重网站的简洁与安全，没有烦人的弹窗广告，让您的观影过程更加纯粹愉悦。
                  </p>
                  <p>
                    作为一家有社会责任感的平台，丫丫影院严格遵守法律法规，所有内容均来源于合法渠道，致力于为广大用户提供安全、健康、优质的在线影视服务。我们相信，好的内容值得被更多人看到。
                  </p>
                </div>
              </div>

              <div className="bg-background-100 rounded-2xl p-6 md:p-8">
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-5">
                  联系方式
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">电子邮箱</p>
                      <a href={`mailto:${siteInfo.email}`} className="text-sm font-medium text-foreground-900 hover:text-primary-600 transition-colors">
                        {siteInfo.email}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                      <i className="ri-phone-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">客服电话</p>
                      <p className="text-sm font-medium text-foreground-900">{siteInfo.phone}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                      <i className="ri-time-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400">工作时间</p>
                      <p className="text-sm font-medium text-foreground-900">周一至周日 9:00 - 22:00</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section className="mb-16">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                  用户口碑
                </h2>
                <p className="text-sm text-foreground-500">听听我们的用户怎么说</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {testimonials.map((t, i) => (
                  <div key={i} className="bg-background-100 rounded-2xl p-6 md:p-7">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: t.rating }).map((_, j) => (
                        <i key={j} className="ri-star-fill text-amber-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      "{t.content}"
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center">
                        <span className="text-sm font-semibold text-primary-700">{t.name.charAt(0)}</span>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                        <p className="text-xs text-foreground-400">{t.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8 text-center">
                常见问题
              </h2>
              <div className="max-w-3xl mx-auto space-y-3">
                {faqs.map((faq, i) => (
                  <details key={i} className="group rounded-xl bg-background-100 p-5 cursor-pointer">
                    <summary className="flex items-center justify-between text-sm font-medium text-foreground-900">
                      {faq.question}
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-lg flex-shrink-0 ml-3"></i>
                    </summary>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </details>
                ))}
              </div>
            </section>
          </div>
        </section>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于丫丫影院",
            "description": siteInfo.description,
            "url": "https://www.yayacinema.com/about",
            "publisher": {
              "@type": "Organization",
              "name": "丫丫影院"
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map((faq) => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })}
        </script>
      </main>
      <Footer />
    </>
  );
}